import React, {useEffect} from 'react'
import {ChakraProvider, Flex, Text, Button, Box} from '@chakra-ui/react'
import {
    BrowserRouter as Router,
    Switch,
    Route, withRouter,
} from "react-router-dom";
import LoginPage from "./Views/LoginPage";
import PageLayout from "./component/PageLayout";
import Lab from "./Views/Lab";
import './App.css'
import ItineraryLab from "./Views/ItineraryLab";
import BarAction from "./component/BarAction";
import EditorPointOfInterest from "./component/EditorPointOfInterest";
import TrashPointOfInterest from "./component/TrashPointOfInterest";
import PartnerMapPage from "./component/PartnerMapPage";
import favicon from './logo_o.png';
import ExternalpartnerMap from "./Views/ExternalpartnerMap";


const BarActionWithRouter = withRouter(BarAction);
const App = () => {

    useEffect(() => document.title = "Explorer Database",[]);

    return(<ChakraProvider resetCSS>
        <Router>
            <Route path={["/lab", "/edit/poi", "/poi/trash", "/itinerary"]}>
                <BarActionWithRouter />
            </Route>
            <Switch>
                <Route exact path="/"><PageLayout isAllowed pageComponent={LoginPage} /></Route>
                <Route exact path="/lab"><PageLayout pageComponent={Lab}/></Route>
                <Route exact path="/edit/poi"><PageLayout pageComponent={EditorPointOfInterest}/></Route>
                <Route exact path="/poi/trash"><PageLayout pageComponent={TrashPointOfInterest}/></Route>
                <Route exact path="/map/partner/:id_partner/:secret_map"><PageLayout pageComponent={PartnerMapPage} /></Route>
            </Switch>
        </Router>
    </ChakraProvider>)
}

export default App
